import { regExp } from '@sigma-frontend-libs/commons'
import { EOtpChannelTypes } from '@sigmasms/shared-types'

import { proxy } from '@/utils'

import render from './render'

export default {
  name: 'Form',

  mixins: [ proxy({ type: 'object' }) ],

  props: {
    isNew: Boolean,
    disabled: Boolean
  },

  computed: {
    isSimPush() {
      return this.proxy.channelType === EOtpChannelTypes.sim_push
    },
    validation() {
      const hasMtsClientId = !!this.proxy.additionalSettings.mtsClientId

      const basic = regExp.titleOtpSettingsSoft.test(this.proxy.name)
      && !!this.proxy.channelType
      && this.proxy.additionalSettings.lifetime > 0
      && this.proxy.additionalSettings.numberOfTries > 0

      let additional = true
      if (this.isSimPush) {
        additional = hasMtsClientId
      }

      return basic && additional
    }
  },

  watch: {
    validation() {
      this.$emit('validation', this.validation)
    }
  },

  mounted() {
    this.$emit('validation', this.validation)
  },

  render
}

